import type { ImageProps } from './Image.types'
import { useCallback, useEffect, useRef, useState } from 'react'
import { mergeRefs } from '../../utils'
import { isSrcInvalid } from '../../utils/images'
import { BaseImage } from './BaseImage'

export function Image({
  ref,
  isEmpty = false,
  ...props
}: ImageProps) {
  const [hasError, setHasError] = useState(false)
  const imgRef = useRef<HTMLImageElement>(null)

  const checkIfImageErrorBeforeHydration = useCallback(() => {
    const wasLoaded = imgRef.current?.complete
    if (wasLoaded && imgRef.current?.naturalWidth === 0) {
      setHasError(true)
    }
  }, [imgRef])

  useEffect(() => {
    checkIfImageErrorBeforeHydration()
  })

  // Guard clause: explicit empty state bypasses error handling
  if (isEmpty) {
    return <BaseImage isEmpty {...props} />
  }

  if (isSrcInvalid(props.src) || hasError) {
    return <BaseImage isEmpty {...props} />
  }

  return (
    <BaseImage
      ref={mergeRefs(ref, imgRef)}
      onErrorCapture={() => setHasError(true)}
      {...props}
    />
  )
}
